import {connect} from 'react-redux';

import Login from './Login';
import {
	check,
	login,
	logout,
	register,
	requestPasswordReset,
	resendVerification
} from '../../actions/authorization';
import {addNotification} from '../../actions/notification';

const mapStateToProps = (state, ownProps) => ({
	...ownProps,
	authorized: state.authorization.authorized,
	loggedIn: state.authorization.loggedIn,
	loggedOut: state.authorization.loggedOut,
	registered: state.authorization.registered,
	passwordResetRequested: state.authorization.passwordResetRequested,
	verificationResent: state.authorization.verificationResent,
	loading: state.authorization.status.loading
});

const mapDispatchToProps = (dispatch) => ({
	check: () => dispatch(check()),
	login: (email, password) => dispatch(login(email, password)),
	logout: () => dispatch(logout()),
	register: (data) => dispatch(register(data)),
	requestPasswordReset: (email) => dispatch(requestPasswordReset(email)),
	resendVerification: (email) => dispatch(resendVerification(email)),
	addNotification: (type, title, message) => dispatch(addNotification(type, title, message))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Login);
